import { render, staticRenderFns } from "./TurnAssigner.vue?vue&type=template&id=cefd057e&lang=pug&"
import script from "./TurnAssigner.vue?vue&type=script&lang=js&"
export * from "./TurnAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports